import { render, staticRenderFns } from "./FinishRegistration.vue?vue&type=template&id=3c06bf7a&scoped=true&"
import script from "./FinishRegistration.vue?vue&type=script&lang=js&"
export * from "./FinishRegistration.vue?vue&type=script&lang=js&"
import style0 from "./FinishRegistration.vue?vue&type=style&index=0&id=3c06bf7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c06bf7a",
  null
  
)

component.options.__file = "FinishRegistration.vue"
export default component.exports